module.exports = __webpack_public_path__ + "img/ep-Z-dosis.b0c9e28e.jpg";